export class Model {
  _name = null
  _schema = {}
  _initial = {}
  _data = {}

  constructor(data = {}, config = {}) {
    if (config.name) this._name = config.name
    if (config.primaryKey) this._primaryKey = config.primaryKey
    if (config.schema) {
      for (const attr in config.schema) {
        this._schema[attr] = this._parseSchemaEntry(config.schema[attr])
      }
    }
    this._loadDefaults()
    if (data) this.setAttributes(data)
    this._initial = {}
  }

  _parseSchemaEntry(entry) {
    if (entry?.constructor === Object) return entry
    if (entry === Array || entry instanceof Array) return { type: Array }
    return { type: entry || String }
  }

  _loadDefaults() {
    for (const attr in this._schema) {
      const schema = this._schema[attr]
      if (schema.default !== undefined) this._data[attr] = schema.default
      else if (schema.type === Object) this._data[attr] = null
      else if (schema.type === Array) this._data[attr] = []
      else this._data[attr] = null
    }
  }

  get(attr) {
    return this._data[attr] ?? null
  }

  set(attr, value, track = true) {
    if (track && !(attr in this._initial)) {
      this._initial[attr] = this._data[attr]
    }
    this._data[attr] = value
  }

  setAttributes(data, track = false) {
    for (const attr in data) {
      if (attr in this._schema) this.set(attr, data[attr], track)
    }
  }

  getData() {
    const data = {}
    for (const attr in this._schema) {
      data[attr] = this._data[attr]
    }
    return JSON.parse(JSON.stringify(data))
  }

  primaryKey() {
    return this._primaryKey || (this._schema.id ? 'id' : null)
  }

  getPrimary() {
    const pk = this.primaryKey()
    return pk ? this.get(pk) : null
  }

  isNew() {
    return this.getPrimary() == null
  }

  isChanged() {
    return Object.keys(this._initial).length > 0
  }

  getChanged() {
    const changed = {}
    for (const attr in this._initial) {
      changed[attr] = this._data[attr]
    }
    return Object.keys(changed).length ? changed : undefined
  }

  clearChanged() {
    this._initial = {}
  }

  revertChanges() {
    for (const attr in this._initial) {
      this._data[attr] = this._initial[attr]
    }
    this._initial = {}
  }

  clone() {
    return new this.constructor(this.getData())
  }
}
